import React from "react";
import { useBillingInfo } from "@hooks/useBillingInfo";
import { Loader } from "@design-system/Loader/Loader";
import { Section } from "@design-system/Section/Section";
import { BillingInfoCard } from "./BillingInfoCard";

export const PaymentDetails: React.FC = () => {
    const { data: billingInfo, isFetched } = useBillingInfo();

    if (!isFetched) {
        return <Loader />;
    }

    if (!billingInfo) {
        return null;
    }

    return (
        <Section heading="Payment details">
            <BillingInfoCard billingInfo={billingInfo} editable />
        </Section>
    );
};
